<script>
import StoreSelection from "@/features/store-locator/store-selection.vue";
import AppConfig from "@/classes/AppConfig";
import axios from "axios";
import {mapActions} from "vuex";
import PersistentData from "@/classes/PersistentData";
import {EVENT_STORE_LOCATOR_SELECT_STORE} from "@/features/store-locator/StoreLocatorEvents";
import featureMixin from "@/mixins/featureMixin";

export default {
	name: "StoreLocatorView",
	components: {StoreSelection},
	mixins: [featureMixin],
	data(){
		return{
			featureEvents: [EVENT_STORE_LOCATOR_SELECT_STORE]
		}
	},

	methods: {
		...mapActions(['setCurrentStore', 'setCurrentStoreObj']),
		...mapActions('storeLocator', ['fetchFiveClosestStores', 'setCurrentLocation', 'toggleStoreSelection']),
		async fetchStoreFromQueryParamStoreId(storeId) {
			const bannerId = AppConfig?.AppConf?.banner_id;
			const storesApiURL = process.env.VUE_APP_STORESAPI_URL;
			const storesApiCode = process.env.VUE_APP_STORESAPI_CODE;
			if (!bannerId || !storesApiCode || !storeId) return null;

			try {
				const {data} = await axios.get(
					`${storesApiURL}/banner/${bannerId}/store/${storeId}/location?code=${storesApiCode}`
				);
				const {latitude, longitude} = data || {};
				if (latitude == null || longitude == null) return null;

				this.setCurrentLocation({latitude, longitude});
				await this.fetchFiveClosestStores();
				if (!Array.isArray(this.closestStores) || !this.closestStores.length) return null;

				return this.closestStores.find((store) => parseInt(store.storeNumber, 10) === parseInt(storeId, 10)) || this.closestStores[0];
			} catch (error) {
				console.error('Unable to resolve store data from query param storeId:', error);
				return null;
			}
		},
		onFeatureEvent(event, data) {
			console.log('Store Locator Event:', event, data);
			if (event === EVENT_STORE_LOCATOR_SELECT_STORE) {
				const {route} = data;
				const rt = route.route;
				if(rt){
					rt.query._ref = 'locsel';
					const rt2 = this.$router.resolve(rt);
					window.location.assign(rt2.href);
				}
			}
		}
	},
	async mounted() {

		const lastStore = new PersistentData('storeLocator');

		if (this.$route.query.locsel === 'clear') {
			lastStore.clear();
		}
		//console.log('lastStore:', lastStore.getData('route'));
		if (lastStore.getData('route') && this.$route.query.locsel !== 'show') {
			window.location.href = lastStore.getData('route')?.href;
			return;
		}
		// When only storeId exists in query, resolve store details through store-locator endpoints.
		if (this.$route.query.storeId) {
			this.setCurrentStore(parseInt(this.$route.query.storeId, 10));
			const resolvedStore = await this.fetchStoreFromQueryParamStoreId(this.$route.query.storeId);
			if (resolvedStore) {
				this.setCurrentStoreObj(resolvedStore);
			}
		}
		this.toggleStoreSelection();
	}
}
</script>

<template>
	<store-selection :event-only="true" :hard-load="true" class="store-locator-standalone"/>
</template>

<style lang="scss">
.store-locator-standalone {
  .header {
	.close-btn {
	  display: none;
	}
  }
}
</style>
